export const LayoutConfigModelDefault = {
    headerConfig: {
        enabled: true,
        logoPro: { enabled: true },
        homeIcon: { enabled: false },
        avatar: { enabled: false },
        title: { enabled: false },
        searchInput: {
            enabled: false,
            placeholder: ""
        },
        nanda: { enabled: false },
        helpCentral: { enabled: true },
        featureNews: { enabled: true },
        profileMenu: { enabled: true },
        closeTimes: { enabled: false }
    },
    sidebarConfig: { enabled: true }
};

export const LayoutConfigModel1 = {
    headerConfig: {
        enabled: true,
        logoPro: { enabled: true },
        homeIcon: { enabled: false },
        avatar: { enabled: false },
        title: { enabled: false },
        searchInput: {
            enabled: true,
            placeholder: ""
        },
        nanda: { enabled: false },
        helpCentral: { enabled: true },
        featureNews: { enabled: true },
        profileMenu: { enabled: true },
        closeTimes: { enabled: false }
    },
    sidebarConfig: { enabled: true }
};

export const LayoutConfigModel2 = {
    headerConfig: {
        enabled: true,
        logoPro: { enabled: true },
        homeIcon: { enabled: false },
        avatar: { enabled: true },
        title: { enabled: false },
        searchInput: {
            enabled: false,
            placeholder: ""
        },
        nanda: { enabled: false },
        helpCentral: { enabled: true },
        featureNews: { enabled: true },
        profileMenu: { enabled: true },
        closeTimes: { enabled: false }
    },
    sidebarConfig: { enabled: true }
};

export const LayoutConfigModel3 = {
    headerConfig: {
        enabled: true,
        logoPro: { enabled: true },
        homeIcon: { enabled: false },
        avatar: { enabled: true },
        title: { enabled: false },
        searchInput: {
            enabled: true,
            placeholder: ""
        },
        nanda: { enabled: true },
        helpCentral: { enabled: true },
        featureNews: { enabled: true },
        profileMenu: { enabled: true },
        closeTimes: { enabled: false }
    },
    sidebarConfig: { enabled: true }
};

export const LayoutConfigModel4 = {
    headerConfig: {
        enabled: true,
        logoPro: { enabled: true },
        homeIcon: { enabled: false },
        avatar: { enabled: true },
        title: { enabled: false },
        searchInput: {
            enabled: false,
            placeholder: ""
        },
        nanda: { enabled: true },
        helpCentral: { enabled: true },
        featureNews: { enabled: true },
        profileMenu: { enabled: true },
        closeTimes: { enabled: false }
    },
    sidebarConfig: { enabled: true }
};

export const LayoutConfigModel5 = {
    headerConfig: {
        enabled: true,
        logoPro: { enabled: true },
        homeIcon: { enabled: false },
        avatar: { enabled: false },
        title: { enabled: true },
        searchInput: {
            enabled: false,
            placeholder: ""
        },
        nanda: { enabled: true },
        helpCentral: { enabled: false },
        featureNews: { enabled: false },
        profileMenu: { enabled: true },
        closeTimes: { enabled: true }
    },
    sidebarConfig: { enabled: true }
};

export const LayoutConfigModel6 = {
    headerConfig: {
        enabled: false,
        logoPro: { enabled: false },
        homeIcon: { enabled: false },
        avatar: { enabled: false },
        title: { enabled: false },
        searchInput: {
            enabled: false,
            placeholder: ""
        },
        nanda: { enabled: false },
        helpCentral: { enabled: false },
        featureNews: { enabled: false },
        profileMenu: { enabled: false },
        closeTimes: { enabled: false }
    },
    sidebarConfig: { enabled: false }
};
